import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { itineraryListData } from '../../../helpers/itineraryHelper';
import DaySvg from '../../shared/UI/daySvg';
import BedSvg from '../../shared/UI/bedSvg';
import BusSvg from '../../shared/UI/busSvg';
import BagSvg from '../../shared/UI/bagSvg';
import PaxButton from '../builder/components/pax-button';
import ButtonSpinner from '../../shared/UI/button-spinner';
import { ISOCurrencyCovert } from '../../../helpers/locationHelper';


class StickyBookingHighlight extends PureComponent{
    
    render(){

        const { itinerary,  currentBooking:{iso_currency, status, prices:{total}, meta:{stops, trips, days} }, view, showAddGapPanel, clickHandler, isSubmitting, isShare } = this.props;
        const _itineraryList = (itinerary === undefined) ? [] : itinerary;       
        const { startCity, lastCity, accommodationNight } = itineraryListData(0, _itineraryList);

        return (
            <div className="clearfix sticky-booking-hightlight booking-highlight md-flex lg-flex px2 py2 xs-hide sm-hide" id="sticky-booking-hightlight">

                <div className={`flex flex-auto ${trips > 0 ? 'flex-column' : 'items-center'}`}>
                    <h3 className="busabout-h3 block">{startCity} to {lastCity}</h3>
                    {
                        trips > 0 && ( 
                        <h5 className="block busabout-h5 viking-text mt1 f-size-14">
                            <svg className="ml1" width="12" height="12" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path fill="#3ABCCB" d="M1600 736v192q0 40-28 68t-68 28h-416v416q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-416h-416q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h416v-416q0-40 28-68t68-28h192q40 0 68 28t28 68v416h416q40 0 68 28t28 68z"></path></svg>
                            {trips} additional trips 
                        </h5>    
                        )
                    } 
                </div>
  
                <div className="flex flex-auto items-center">
 
                        <span className="icon-container">
                            <DaySvg clazz={"mr1"} /> <span className="bold mr2">{days} days</span>
                            <BedSvg clazz={"mr1"} /> <span className="bold mr2">{accommodationNight} nights</span>
                            <BusSvg clazz={"mr1"} /> <span className="bold mr2">{stops} stops</span>
                            { trips > 0 && <><BagSvg clazz={"mr1"} /> <span className="bold mr2">{trips} trips</span></> }
                        </span>

                        { (!isShare && view !== "builder") && <PaxButton clazz={"ml3"}/> }
           
                </div>
 
                <div className="flex items-center">
  
                    { 
                        (view === 'builder' && _itineraryList.length > 1 && !showAddGapPanel && !isShare) && (
                            <button 
                                className="busabout--cta orange rounded-corner" 
                                onClick={() => clickHandler() } 
                                disabled={stops >= 1 ? false : true}>
                                Get Price Quote
                            </button>
                        )
                    }
    
                    { 
                        (view === 'itinerary') && (
                            <button className={`busabout--cta rounded-corner ${(status === "confirmed") ? 'green-background' : 'orange'} ${status === "confirmed" ? 'no-pointer-event': ''}`}  onClick={() => { if(status !== "confirmed" ) clickHandler() }} disabled={itinerary !== undefined && stops >= 1 ? false : true}>
                            { 
                                !isSubmitting && (
                                    <>
                                    { (!isShare && status !== "confirmed") && ('Book now') }
                                    { (!isShare && status === "confirmed") && ('Confirmed') }
                                    { (isShare && status !== "confirmed") && ('Your Quote') }
                                    { (isShare && status === "confirmed") && ('Confirmed') }    

                                    {(!isShare) && <span className="f-size-12 regular price"> {ISOCurrencyCovert(iso_currency).props.children}{total} {iso_currency}</span>}
                                    </> 
                                )
                            }
                            { isSubmitting &&  <ButtonSpinner /> } 
                            </button>
                        )
                    }

                </div>
    
            </div>

        )
    }

}

const mapStateToProps = state => {
    return{
        currentBooking:state.currentBooking,
        itinerary:state.currentBooking.itinerary, 
        agent:state.agent,
        meta:state.currentBooking.meta
    }
}

export default connect(mapStateToProps, null)(StickyBookingHighlight);

